export default __webpack_public_path__ + "static/media/LastPage2.ab677b9f.txt";